
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();


export const getpropertyType = async () => {
   
 
    const response = await authenticatedFetch(`${config.API_BASE_URL}/propertyType`, {
        method: 'GET',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        }
      });
   
      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        throw new Error(`Error getting property type`);
      }




};


export const getpropertySubType = async (type) => {
 



  const response = await authenticatedFetch(`${config.API_BASE_URL}/propertySubType`, {
      method: 'POST',
      headers: {
      
        'Content-Type': 'application/json',
        'User-Agent': 'agentApp/1.0',
      },
      body: JSON.stringify({type: type}),
    });
 
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else {
      throw new Error(`Error getting property subtype`);
    }




};